import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  auth: {
    username: process.env.REACT_APP_AUTH_USER,
    password: process.env.REACT_APP_AUTH_PASS,
  },
  headers: {
    "Cache-Control": "no-store",
    "x-database": process.env.REACT_APP_X_DATABASE,
  },
});

export const getResultadoExames = async (cpf, dt_nascimento, id_paciente) => {
  return await api.get(
    "/resultados_exames?cpf=" +
      cpf +
      "&dt_nascimento=" +
      dt_nascimento +
      "&id_paciente=" +
      id_paciente
  );
};

export const getOpenFile = async (filename) => {
  return await api.get("/open_file?filename=" + filename, {
    responseType: "arraybuffer",
    headers: {
      "Contetnt-Type": "application/pdf",
    },
  });
};
